/**
 * Community Page Component
 * Renders an overview of Clipstone Community activities, pillars (Sports & Recreation, Youth Centre,
 * Community Events, Heritage & Environment), and facility highlights.
 */

import React, { useEffect, useState } from 'react';
import './Community.css';
import { getSiteContent } from '../utils/siteContent';

// Community overview content configuration
const Community = () => {
    const [siteContent, setSiteContent] = useState(() => getSiteContent());

    useEffect(() => {
        const handleContentUpdate = () => setSiteContent(getSiteContent());
        window.addEventListener('site-content-updated', handleContentUpdate);
        return () => window.removeEventListener('site-content-updated', handleContentUpdate);
    }, []);

    return (
        <div className="community-page" style={{ maxWidth: '900px', margin: '0 auto', padding: '20px', fontFamily: 'Arial, sans-serif' }}>

            {/* Header Section */}
            <header style={{ marginBottom: '40px' }}>
                <h1 style={{ color: '#1b4332', borderBottom: '2px solid #2d6a4f', paddingBottom: '10px' }}>{siteContent.community.title}</h1>
                <p style={{ fontSize: '1.1em', color: '#555', lineHeight: '1.6', marginTop: '20px' }}>{siteContent.community.mission}</p>
            </header>

            {/* Pillars Grid */}
            <section style={{ marginBottom: '40px' }}>
                <h2 style={{ color: '#2d6a4f', marginBottom: '20px' }}>What We Offer</h2>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px' }}>
                    {siteContent.community.pillars.map((pillar, index) => (
                        <div key={index} style={{ background: '#f4f9f4', padding: '20px', borderRadius: '8px', borderLeft: '4px solid #52b788' }}>
                            <h3 style={{ marginTop: 0, color: '#1b4332' }}>{pillar.title}</h3>
                            <p style={{ marginBottom: 0, fontSize: '0.95em', color: '#333', lineHeight: '1.5' }}>{pillar.description}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* Footer / Contact Section */}
            <footer style={{ background: '#1b4332', color: 'white', padding: '25px', borderRadius: '8px', marginTop: '40px' }}>
                <h3 style={{ marginTop: 0, color: 'white' }}> Get Involved</h3>
                <p style={{ margin: '8px 0' }}><strong> Address:</strong> Clipstone Miners Welfare Institute, Mansfield Road, Clipstone Village, Mansfield, NG21 9AL</p>
                <p style={{ margin: '8px 0' }}><strong> Phone:</strong> 01623 627006 / 01623 622098</p>
                <p style={{ margin: '8px 0' }}>
                    <strong>Email:</strong> <a href="mailto:info@clipstonewelfare.co.uk" style={{ color: '#95d5b2', textDecoration: 'none' }}>info@clipstonewelfare.co.uk</a>
                </p>
            </footer>

        </div>
    );
};

export default Community;